import { Avatar } from '@dealstack/frontend/shared/components/Avatar/Avatar';
import { Text } from '@mantine/core';

interface Props {
	icon?: React.ReactNode;
	text: React.ReactNode;
}

export const ProfileBox = ({ icon, text }: Props) => {
	const TextElement =
		typeof text === 'string' ? (
			<Text
				data-testid={`profile-box-${text}`}
				size="B6Bold"
				c="dark.8"
				truncate
				lineClamp={1}
			>
				{text}
			</Text>
		) : (
			text
		);

	return (
		<div className="flex gap-4 p-4 border border-solid rounded-lg bg-[#F4F5F6] border-[#E6E9EB] items-center">
			{icon && <Avatar children={icon} />}
			{TextElement}
		</div>
	);
};
